module.exports = __webpack_public_path__ + "static/media/optimusLogo.f85cf580.svg";